import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PageDefault from '../../../components/PageDefault';
import Button from '../../../components/Button';
import FormField from '../../../components/FormField';
import useForm from '../../../hooks/useForm';



function CadastroCategoria() {

  const initialValues = {
    title: '',
    desc: '',
    color: '',
  }

  const { handleChange, values, clearForm } = useForm(initialValues);

  const [categorias, setCategoria ] = useState([]);

  useEffect(() => {
      const URL_CATEGORIAS = window.location.hostname.includes('localhost') 
           ? 'http://localhost:8080/categorias'
           : 'https://metflix-backend.herokuapp.com/categorias';
      fetch(URL_CATEGORIAS)
          .then(async (data) => {
              const resposta = await data.json();
              setCategoria([...categorias, ...resposta]);
          });
  }, [])

  return (
        <PageDefault>
            <h1>Cadastro de Categoria: {values.title}</h1>

            <form onSubmit={(e) => { e.preventDefault()
                            setCategoria([...categorias,values, ])
                  clearForm(initialValues);              
              }}
            >
                { /* State */}
                <FormField 
                  label="Titulo"
                  type="text"
                  name="title"
                  value={values.title}
                  onChange={handleChange}

                />
                <br />
                <FormField 
                  label="Descrição"
                  type="textarea"
                  name="desc"
                  value={values.desc}
                  onChange={handleChange}

                /><br />
                <FormField    
                  label="Cor"               
                  type="color"
                  name="color"
                  value={values.color}
                  onChange={handleChange}

                />
                <Button>Cadastrar</Button>
            </form>

            
            <ul>
            {categorias.map((categoria, key) => {
                    return (
                      <li key={`${categoria.title}${key}`}>
                          {categoria.title}
                      </li>
                    )
                  })
                }
                
            </ul>
          <Link to="/">
            Ir para Home
          </Link> 
        </PageDefault>
    );
}

export default CadastroCategoria;